"use client";

import Script from "next/script";

export default function HubSpot() {
    return (
        <Script
            id="hs-script-loader"
            src="//js-na2.hs-scripts.com/242843279.js"
            type="text/javascript"
            async defer
        />
    );
}
